import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
  Menu,
  MenuItem,
  Button,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  Android as AndroidIcon,
  MoreVert as MoreVertIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import NewTicketButtonSlot from "../PluginBridge/slots/NewTicketButtonSlot";
import PluginBridge, { usePluginBridge } from "../PluginBridge";
import { tickets as ticketsUI } from "@markedesk/plugin-sdk/ui";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import CloseAllTicketsModal from "../CloseAllTicketsModal";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import {
  canUseGroups,
  tabAfterGroupAccessLost
} from "../../utils/groupAccess";
import { needsQueueSync } from "../../utils/queueSelection";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: "8px",
    margin: "0 4px",
    opacity: 0.7,
    "&.Mui-selected": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "30%",
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: "28%",
      fontSize: 8,
    },
  },

  tabIndicator: {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    transition: "all 0.3s ease",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.optionsBackground,
    borderRadius: 8,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5),
  },

  serachInputWrapper: {
    flex: 1,
    height: 40,
    background: theme.palette.total,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-12px",
    top: "-10px",
    transform: "translate(30%, -30%)",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  
  modernTabs: {
    minHeight: 54,
    borderRadius: 8,
    backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.02)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    padding: "8px 4px 4px 4px", // Aumentamos o padding superior para dar espaço ao badge
    margin: "8px 0",
    transition: "all 0.3s ease",
    position: "relative",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 30,
    width: 30,
    border: "2px solid #aaa",
    borderRadius: 8,
    marginRight: 8,
    padding: 0,
    minWidth: 'auto',
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      marginRight: 6,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      marginRight: 6,
    },
  },
  activeButton: {
    borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    borderWidth: "3px",
  },
  standardIcon: {
    color: "#aaa",
    fontSize: 18,
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const ticketBridge = usePluginBridge("create-ticket");

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState(() => {
    return localStorage.getItem("ticketsTab") || "open";
  });
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(() => {
    return localStorage.getItem("ticketsShowAll") === "true";
  });
  const [sortTickets, setSortTickets] = useState(() => {
    return localStorage.getItem("ticketsSortAZ") === "true";
  });

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const canShowAllTickets =
    user.profile?.toUpperCase() === "ADMIN" ||
    user.allUserChat?.toUpperCase() === "ENABLED";
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);
  const { whatsApps } = useContext(WhatsAppsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = (user?.queues || []).map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("ticketsQueueIds"));
      if (Array.isArray(saved)) {
        const valid = saved.filter((id) => userQueueIds.includes(id));
        if (valid.length > 0) return valid;
      }
    } catch (e) {}
    return userQueueIds || [];
  });
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [closeAllModalOpen, setCloseAllModalOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);
  const [optionsMenuOpen, setOptionsMenuOpen] = useState(false);
  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] = useState(null);

  // O inicializador do useState acima roda UMA vez, e no primeiro render o
  // `user` do AuthContext ainda é `{}` — então a seleção congelava vazia e
  // nada a corrigia. Com ela vazia, o handler de socket do TicketsListCustom
  // apaga da tela todo ticket que ganha fila: o atendimento aparece e some em
  // ~1s, enquanto o F5 mostra tudo (a listagem vem da API, que decide pelo
  // usuário no servidor). Sincroniza uma única vez, para não desfazer quem
  // desmarcou tudo de propósito.
  const filasJaSincronizadas = useRef(selectedQueueIds.length > 0);
  const chaveDasFilasDoUsuario = userQueueIds.join(",");
  useEffect(() => {
    if (!needsQueueSync(selectedQueueIds, userQueueIds, filasJaSincronizadas.current)) {
      return;
    }
    filasJaSincronizadas.current = true;
    setSelectedQueueIds(userQueueIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chaveDasFilasDoUsuario]);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    const savedShowAllPreference = localStorage.getItem("ticketsShowAll");

    if (!canShowAllTickets) {
      setShowAllTickets(false);
      return;
    }

    if (savedShowAllPreference === null) {
      setShowAllTickets(true);
      return;
    }

    setShowAllTickets(savedShowAllPreference === "true");
  }, [canShowAllTickets]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setTab("open");
      localStorage.setItem("ticketsTab", "open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const hiddenStyle = useMemo(() => ({ width: 0, height: 0 }), []);
  const openStyle = useMemo(() => tabOpen !== "open" ? hiddenStyle : undefined, [tabOpen, hiddenStyle]);
  const pendingStyle = useMemo(() => tabOpen !== "pending" ? hiddenStyle : undefined, [tabOpen, hiddenStyle]);
  const groupStyle = useMemo(() => tabOpen !== "group" ? hiddenStyle : undefined, [tabOpen, hiddenStyle]);

  // #4453 — a tab "Grupos" só faz sentido quando ESTE usuário tem acesso a
  // uma conexão que aceita grupos (regra em utils/groupAccess, compartilhada
  // com o "Novo Ticket"). Se nenhuma aceita, não há ticket de grupo para
  // listar — e deixar a tab visível só confunde (o cliente clica, não aparece
  // nada, e reporta como "não recebi").
  const showGroupTab = useMemo(
    () => canUseGroups(whatsApps, user),
    [whatsApps, user]
  );

  // A tab pode sumir com ela ABERTA (o admin desliga "permitir grupos" na
  // conexão enquanto o atendente está na aba) — regra e motivo em
  // utils/groupAccess#tabAfterGroupAccessLost.
  useEffect(() => {
    const next = tabAfterGroupAccessLost(tabOpen, showGroupTab);
    if (next) setTabOpen(next);
  }, [showGroupTab, tabOpen, setTabOpen]);

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  // Mensagens vindas do painel de plugin (iframe) no slot do botão Novo Ticket.
  const handlePluginMessage = async (data, closeModal) => {
    try {
      if (data.action === "create-ticket" || data.action === "ticket-created") {
        // O app (com JWT) cria/abre o ticket. NotificameHub já disparou a conversa.
        let contactId = data.contactId;

        // Sem contactId (número digitado): acha ou cria o contato pelo número.
        if (!contactId && data.number) {
          const { data: contact } = await api.post("/contacts", {
            name: data.number,
            number: String(data.number).replace(/\D/g, "")
          });
          contactId = contact?.id;
        }
        if (!contactId) {
          console.log("Sem contato para criar o ticket");
          return;
        }

        // Cria o ticket através do pipeline de plugins (before -> on -> after).
        // Plugins podem interceptar (ex: exigir/validar template antes).
        const conn = (whatsApps || []).find((w) => String(w.id) === String(data.whatsappId));
        const ticket = await ticketBridge.run(
          {
            payload: { contactId, whatsappId: data.whatsappId, userId: user.id, status: "open" },
            source: data,                          // { number, template..., contactId }
            connection: conn ? { id: conn.id, channel: conn.channel } : null
          },
          async (ctx) => {
            const { data: t } = await api.post("/tickets", ctx.payload);
            return t;
          }
        );
        if (!ticket) return; // cancelado por algum interceptador "before"
        if (closeModal) closeModal();
        handleCloseOrOpenTicket(ticket);
      }
    } catch (err) {
      console.log("Erro ao criar ticket via plugin:", err);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
      localStorage.setItem("ticketsTab", "open");
      setSearchParam("");
      setSelectedTags([]);
      setSelectedUsers([]);
      setSelectedWhatsapp([]);
      setSelectedStatus([]);
      setForceSearch(!forceSearch);
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      setTab("search");
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  // Funções para controlar o dropdown de opções
  const handleOptionsMenuOpen = (event) => {
    setOptionsMenuAnchorEl(event.currentTarget);
    setOptionsMenuOpen(true);
  };

  const handleOptionsMenuClose = () => {
    setOptionsMenuOpen(false);
    setOptionsMenuAnchorEl(null);
  };

  // Função para alternar entre abertos/fechados
  const handleStatusTabChange = (newTab) => {
    setTab(newTab);
    localStorage.setItem("ticketsTab", newTab);
    handleOptionsMenuClose();
  };

  // Função para alternar mostrar todos os tickets
  const handleToggleShowAllTickets = () => {
    setShowAllTickets((prevState) => {
      const nextState = !prevState;
      localStorage.setItem("ticketsShowAll", String(nextState));
      return nextState;
    });
    handleOptionsMenuClose();
  };

  // Função para alternar ordenação
  const handleToggleSortTickets = () => {
    setSortTickets((prevState) => {
      localStorage.setItem("ticketsSortAZ", String(!prevState));
      return !prevState;
    });
    handleOptionsMenuClose();
  };

  // Função para fechar todos os tickets
  const handleCloseAllFromMenu = () => {
    setCloseAllModalOpen(true);
    handleOptionsMenuClose();
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
        <IconButton
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            borderRadius: "50%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          variant="contained"
          aria-label="filter"
          className={classes.filterIcon}
          onClick={() => {
            setIsFilterActive((prevState) => !prevState);
            handleFilter();
          }}
        >
          {isFilterActive ? (
            <FilterAlt className={classes.icon} />
          ) : (
            <FilterAltOff className={classes.icon} />
          )}
        </IconButton>
      </div>

      {filter === true && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            {/* Botão Novo Ticket — envolto em slot de plugin (add/desabilitar/substituir) */}
            <NewTicketButtonSlot companyId={user?.companyId} onPluginMessage={handlePluginMessage}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => setNewTicketModalOpen(true)}
                style={{ marginRight: 8 }}
              >
                {i18n.t("tickets.inbox.newTicket")}
              </Button>
            </NewTicketButtonSlot>
          </Grid>

          <Grid item>
            {/* Seletor de Filas */}
            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => {
                setSelectedQueueIds(values);
                localStorage.setItem("ticketsQueueIds", JSON.stringify(values));
              }}
            />
          </Grid>

          <Grid item>
            {/* Botão + Opções */}
            <Button
              variant="outlined"
              size="small"
              endIcon={<MoreVertIcon />}
              onClick={handleOptionsMenuOpen}
            >
              + Opções
            </Button>
          </Grid>

          <Grid item>
            {/*
              Ações de plugin sobre a CAIXA, não sobre um atendimento. É o
              único ponto desta tela que não depende de conversa aberta — o
              `new-ticket-button` ao lado SUBSTITUI o botão nativo, então não
              servia para somar. Contexto de propósito enxuto: quem age aqui
              age sobre a empresa, não sobre um ticket.
            */}
            <PluginBridge
              slot={ticketsUI.slots.LIST_ACTIONS}
              as="text-buttons"
              context={{ companyId: user?.companyId }}
              onPluginMessage={handlePluginMessage}
            />
          </Grid>
        </Grid>

        {/* Menu dropdown das opções */}
        <Menu
          anchorEl={optionsMenuAnchorEl}
          open={optionsMenuOpen}
          onClose={handleOptionsMenuClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {/* Opção: Abertos */}
          <MenuItem onClick={() => handleStatusTabChange("open")}>
            <MoveToInboxIcon style={{ marginRight: 8 }} />
            {i18n.t("tickets.inbox.open")}
          </MenuItem>

          {/* Opção: Resolvidos */}
          <MenuItem onClick={() => handleStatusTabChange("closed")}>
            <CheckBoxIcon style={{ marginRight: 8 }} />
            {i18n.t("tickets.inbox.resolverd")}
          </MenuItem>

          {/* Opção: Todos */}
          <Can
            role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
            perform="tickets-manager:showall"
            yes={() => (
              <MenuItem onClick={handleToggleShowAllTickets}>
                {showAllTickets ? (
                  <VisibilityIcon style={{ marginRight: 8 }} />
                ) : (
                  <VisibilityOffIcon style={{ marginRight: 8 }} />
                )}
                Todos
              </MenuItem>
            )}
          />

          {/* Opção: Ordenar A-Z */}
          {tab !== "closed" && tab !== "search" && (
            <MenuItem onClick={handleToggleSortTickets}>
              {!sortTickets ? (
                <TextRotateUp style={{ marginRight: 8 }} />
              ) : (
                <TextRotationDown style={{ marginRight: 8 }} />
              )}
              {!sortTickets ? "Ordenar A-Z" : "Ordenar Z-A"}
            </MenuItem>
          )}

          {/* Opção: Fechar todos */}
          {user.profile === "admin" && (
            <MenuItem onClick={handleCloseAllFromMenu}>
              <PlaylistAddCheckOutlined style={{ marginRight: 8 }} />
              {i18n.t("tickets.inbox.closedAll")}
            </MenuItem>
          )}
        </Menu>

        <CloseAllTicketsModal
          open={closeAllModalOpen}
          onClose={() => setCloseAllModalOpen(false)}
          defaultStatus={tabOpen}
          userQueues={user?.queues}
        />
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      fontWeight: tabOpen === "open" ? 700 : 500,
                      color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <ClockIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      fontWeight: tabOpen === "pending" ? 700 : 500,
                      color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {showGroupTab && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                  <Grid item>
                    <Badge
                      overlap="circular"
                      max={999}
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <Group
                        style={{
                          fontSize: 20,
                          color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 11,
                        fontWeight: tabOpen === "group" ? 700 : 500,
                        color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={setOpenCount}
            style={openStyle}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={canShowAllTickets ? showAllTickets : false}
            updateCount={setPendingCount}
            style={pendingStyle}
            setTabOpen={setTabOpen}
          />
          {showGroupTab && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={setGroupingCount}
              style={groupStyle}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={canShowAllTickets ? showAllTickets : false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
